import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  __async,
  __objRest,
  __spreadValues
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/auction/checkoutPayment.ts
import { Exception } from "@wbk/logger";
var checkoutAuctionPayment = (props) => __async(void 0, null, function* () {
  var _b;
  const _a = props, { payment_session_id, lang = "en" } = _a, rest = __objRest(_a, ["payment_session_id", "lang"]);
  try {
    const response = yield fetchClient({
      url: "auctions/proceed-payment-link",
      options: {
        method: "POST",
        body: JSON.stringify(__spreadValues({
          payment_session_id,
          lang
        }, rest))
      }
    });
    if (!((_b = response == null ? void 0 : response.data) == null ? void 0 : _b.redirect_url)) {
      const msg = (response == null ? void 0 : response.message) || "Missing redirect URL";
      throw new Error(msg);
    }
    return response.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "checkoutAuctionPaymentException",
      context: { extra: { payment_session_id, lang }, tags: { journey: "checkout" } }
    });
  }
});

export {
  checkoutAuctionPayment
};
//# sourceMappingURL=chunk-IDRAWCQV.mjs.map